export default {
  oktaBaseUrl: "https://okta.debeersgroup.com", //NOTE: prod environment uses the okta base url for getValidateAuthenticationUrl in helpers.ts.
  oktaPreviewBaseUrl: "https://oktapreview.debeersgroup.com",
  oidc: {
    issuer: "https://okta.debeersgroup.com/oauth2/ausc91qfakXjqOkFj0i7",
    clientId: "0oac91p2nyzHP0xRk0i7",
    scopes: ["openid", "profile", "email", "groups"],
    redirectUri: `${window.location.origin}`,
    pkce: true,
  },
  widget: {
    issuer: "https://okta.debeersgroup.com/oauth2/ausc91qfakXjqOkFj0i7",
    clientId: "0oac91p2nyzHP0xRk0i7",
    redirectUri: `${window.location.origin}`,
    scopes: ["openid", "profile", "email", "groups"],
    useInteractionCodeFlow: "false",
    useClassicEngine: "true",
    features: {
      selfServiceUnlock: true,
    },
    i18n: {
      en: {
        'rememberDevice.timebased': 'Do not ask me for Multi Factor Authentication (MFA) again on this device for the next {0}',
        'rememberDevice.devicebased': 'Do not ask me for Multi Factor Authentication (MFA) again on this device'
      }
    }
  },
};
